module.exports = __webpack_public_path__ + "img/detail-1.998dc887.jpg";